export default __webpack_public_path__ + "static/media/308 04222022_tn.de472040.jpg";